<template>
  <div>
    <div v-if="form" style="text-align: right;" dir="rtl">
      <div v-if="payload.is_create">
        <p class="bold">Language</p>
        <select dir="rtl" v-model="form.data.language.fields.language_id.value"
          ><option
            :key="'language_' + language.id"
            v-for="language in languages"
            :value="language.id"
            >{{ language.name }}</option
          ></select
        >
      </div>
      <div>
        <p class="bold">Reading</p>
        <select dir="rtl" v-model="form.data.language.fields.reading.value"
          ><option
            :key="'reading_' + option.value"
            v-for="option in options"
            :value="option.value"
            >{{ option.text }}</option
          ></select
        >
      </div>
      <div>
        <p class="bold">Writing</p>
        <select dir="rtl" v-model="form.data.language.fields.writing.value"
          ><option
            :key="'writing_' + option.value"
            v-for="option in options"
            :value="option.value"
            >{{ option.text }}</option
          ></select
        >
      </div>
      <div>
        <p class="bold">Verbal</p>
        <select dir="rtl" v-model="form.data.language.fields.verbal.value"
          ><option
            :key="'verbal_' + option.value"
            v-for="option in options"
            :value="option.value"
            >{{ option.text }}</option
          ></select
        >
      </div>
    </div>
    <div class="modal_footer">
      <a
        @click="submit()"
        :class="{ 'is-loading': is_loading }"
        class="button is-info"
        >Submit</a
      >
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import LanguagesHelper from '@/custom/classes/languages_helper.js'
export default {
  props: ['payload'],
  name: 'applicant-languages-form',
  data () {
    let languages_helper = new LanguagesHelper()
    return {
      languages: [],
      is_loading: false,
      form: undefined,
      applicant_id: this.payload.applicant_id,
      languages_helper: languages_helper,
      options: languages_helper.getOptions()
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.$network_utils.getAllLanguages().then(languages => {
        this.languages = languages
      })
      if (this.payload.is_create) {
        this.setForm({
          id: ''
        })
        return
      }
      this.$network_utils.getApplicantLanguage({ applicant_language_id: this.payload.data.id, current_applicant_id: this.applicant_id }).then(response => {
        this.setForm(response)
      })
    },
    setForm (form_data) {
      this.form = new this.$form({
        language: {
          fields: {
            language_id: {
              value: form_data.language_id,
              has_error: false,
              validations: []
            },
            reading: {
              value: form_data.reading,
              has_error: false,
              validations: []
            },
            writing: {
              value: form_data.writing,
              has_error: false,
              validations: []
            },
            verbal: {
              value: form_data.verbal,
              has_error: false,
              validations: []
            },
            current_applicant_id: {
              value: this.payload.applicant_id,
              has_error: false,
              validations: []
            },
            id: {
              value: form_data.id,
              has_error: false,
              validations: []
            }
          },
          request_details: {
            method: this.payload.is_create ? 'post' : 'put',
            url: '/applicants/languages/' + form_data.id,
            headers: 'applicant_headers'
          },
          is_used: true
        }
      })
    },
    submit () {
      let response = this.form.mySubmit()
      if (response === false) {
        return
      }
      this.is_loading = true
      response.promise.then((response) => {
        this.is_loading = false
        this.$utils.emit('show_toast', { text: 'success' })
        this.remove(this.payload)
      })
    },
    ...mapMutations('modals', ['remove'])
  }
}
</script>
